import NewsletterDropin from '../components/NewsletterDropin';
import NewsletterPopup from '../components/NewsletterPopup';
import tippy from 'tippy.js';

class Newsletter {
	constructor(elm, type) {
		this.newsletter = elm;
		this.type = type;
		this.form = this.newsletter.querySelector('form');
		this.input = this.newsletter.querySelector('[type="email"]');

		this.isSubmitting = false;
		this.success = false;
		this.isSubscribed = localStorage.getItem('newsletter');

		this.tippy = null;

		if (this.isSubscribed) {
			this.subscribed();
			return;
		}

		if (type === 'dropin') {
			this.dropin = new NewsletterDropin(this);
		}

		if (type === 'popup') {
			this.popup = new NewsletterPopup(this);
		}

		this.form.addEventListener('submit', e => {
			this.submit();
			e.preventDefault();
		});
	}

	displaySuccess(data) {
		if (!data.success) {
			this.displayFailure(data.data.message);
			return;
		}

		localStorage.setItem('newsletter', 'subscribed');
		this.isSubscribed = localStorage.getItem('newsletter');
		this.success = true;
		this.subscribed();
		this.track();
	}

	displayFailure(error) {
		console.error('Error:', error);

		this.isSubmitting = false;

		let tippyContent = error;

		// Replace the mailchimp error message with the following text
		if (error.includes('member')) {
			tippyContent = 'This email address is already subscribed';
		}

		this.showTippy(tippyContent);
	}

	showTippy(content) {
		this.tippy = tippy(this.input, {
			content: content,
			allowHTML: true,
			interactive: true,
			placement: 'top',
			theme: 'emergence-newsletter',
			animation: 'fade',
			showOnCreate: true,
			hideOnClick: true,
			trigger: 'manual',
		});
	}

	destroyTippy() {
		if (!this.tippy) {
			return;
		}

		this.tippy.destroy();
		this.tippy = null;
	}

	submit() {
		this.destroyTippy();

		if (this.isSubmitting) {
			return; // Prevent multiple submit requests
		}

		this.isSubmitting = true;

		fetch(this.form.action, {
			method: 'POST',
			body: new FormData(this.form),
		})
			.then(response => response.json())
			.then(data => this.displaySuccess(data))
			.catch(error => this.displayFailure(error));
	}

	subscribed() {
		this.newsletter.classList.add('subscribed');

		if (this.dropin) {
			this.dropin.closeAndHide();
			this.dropin.dropin.destroy();
		}

		if (this.popup) {
			setTimeout(() => {
				this.popup.hide();
			}, 2000);
		}
	}

	track() {
		if (!window.WPURLS.in_production) {
			return;
		}

		gtag('event', 'newsletter', {
			'type': this.type,
		});

		if (window.plausible) {
			plausible('newsletter', {
				props: {
					'type': this.type,
				}
			});
		}
	}
}

export default class NewsletterManager {
	constructor() {
		this.init();

		document.addEventListener('bless', ({ detail }) => {
			this.newsletters = detail.next.container.querySelectorAll('[data-newsletter]');

			this.newsletters.forEach((elm, index) => {
				const type = elm.getAttribute('data-newsletter');
				if (type === 'popup') {
					new Newsletter(elm, type);
				}
				if (type === 'inline') {
					new Newsletter(elm, type);
				}
			});
		});
	}

	init() {
		document.fonts.ready.then(() => {
			this.newsletters = document.querySelectorAll('[data-newsletter]');
			this.newsletters.forEach((elm, index) => {
				const type = elm.getAttribute('data-newsletter');
				if (type === 'dropin') {
					new Newsletter(elm, type);
				}
			});
		});
	}
}
